var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-advertiser'),_c('list-advertiser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }